// Found on (https://developers.facebook.com/docs/facebook-pixel/reference#events)
// Please note more can be defined but these are the "defaults"
export enum PixelEventNames {
  AddPaymentInfo = 'AddPaymentInfo',
  AddToCart = 'AddToCart',
  AddToWishlist = 'AddToWishlist',
  CompleteRegistration = 'CompleteRegistration',
  Contact = 'Contact',
  CustomizeProduct = 'CustomizeProduct',
  Donate = 'Donate',
  FindLocation = 'FindLocation',
  InitiateCheckout = 'InitiateCheckout',
  Lead = 'Lead',
  PageView = 'PageView',
  Purchase = 'Purchase',
  Schedule = 'Schedule',
  Search = 'Search',
  StartTrial = 'StartTrial',
  SubmitApplication = 'SubmitApplication',
  Subscribe = 'Subscribe',
  ViewContent = 'ViewContent',
}

/**
 * @description Pixel event type used when configuring campaigns
 */
export enum PixelEventType {
  ADD_PAYMENT_INFO = 'ADD_PAYMENT_INFO',
  ADD_TO_CART = 'ADD_TO_CART',
  ADD_TO_WISHLIST = 'ADD_TO_WISHLIST',
  COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION',
  CONTENT_VIEW = 'CONTENT_VIEW',
  INITIATED_CHECKOUT = 'INITIATED_CHECKOUT',
  LEAD = 'LEAD',
  PURCHASE = 'PURCHASE',
  SEARCH = 'SEARCH',
  CONTACT = 'CONTACT',
  CUSTOMIZE_PRODUCT = 'CUSTOMIZE_PRODUCT',
  DONATE = 'DONATE',
  FIND_LOCATION = 'FIND_LOCATION',
  SCHEDULE = 'SCHEDULE',
  START_TRIAL = 'START_TRIAL',
  SUBMIT_APPLICATION = 'SUBMIT_APPLICATION',
  SUBSCRIBE = 'SUBSCRIBE',
  LISTING_INTERACTION = 'LISTING_INTERACTION',
  FACEBOOK_SELECTED = 'FACEBOOK_SELECTED',
  OTHER = 'OTHER',
}
